import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage"
import CitiesServices from "services/Admin/CitiesService"

const FacilitiesPage = (props) => {
        return <SystemPage
                Service={CitiesServices}
                type={"City"}
                placeholder={"city"}
                meta={"Cities"}
                header={"Cities"}
                hasSub={false}
        />

}

export default FacilitiesPage;
